import { render, staticRenderFns } from "./deliveryUnitAccessList.vue?vue&type=template&id=3cd86bf0&"
import script from "./deliveryUnitAccessList.vue?vue&type=script&lang=js&"
export * from "./deliveryUnitAccessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports